export default __webpack_public_path__ + "static/bg-numbers-8b9071f3b11cbdfebf109e54782f9c3c.jpg";